// src/components/ui/Breadcrumb.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react"; // guaranteed working icon

// ⚠ remove import Icon from '../AppIcon';
// Safari crashes when Icon is undefined.
// We now use lucide-react icons directly.

const Breadcrumb = ({ items = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const defaultBreadcrumbs = {
    "/dashboard": [{ label: "Dashboard", path: "/dashboard" }],
    "/new-analysis": [
      { label: "Dashboard", path: "/dashboard" },
      { label: "New Analysis", path: "/new-analysis" },
    ],
    "/analysis-results": [
      { label: "Dashboard", path: "/dashboard" },
      { label: "New Analysis", path: "/new-analysis" },
      { label: "Analysis Results", path: "/analysis-results" },
    ],
    "/patient-records": [
      { label: "Dashboard", path: "/dashboard" },
      { label: "Patient Records", path: "/patient-records" },
    ],
    "/account-settings": [
      { label: "Dashboard", path: "/dashboard" },
      { label: "Account Settings", path: "/account-settings" },
    ],
  };

  const breadcrumbItems =
    items?.length > 0 ? items : defaultBreadcrumbs?.[location?.pathname] || [];

  if (!breadcrumbItems || breadcrumbItems.length <= 1) return null;

  const handleNavigation = (path) => {
    if (path && path !== location?.pathname) navigate(path);
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-white/40 mb-6">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <ChevronRight
              size={14}
              className="text-white/30 inline-block"
            />
          )}

          {index === breadcrumbItems.length - 1 ? (
            <span className="text-white/80 font-medium">{item.label}</span>
          ) : (
            <button
              onClick={() => handleNavigation(item.path)}
              className="hover:text-white/70 transition-colors duration-200"
            >
              {item.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
